<template>
  <div class="bx-carousel">
    <img v-on:click="prevSlide()" v-if="this.currentSlide > 1" src="/static/img/icons/keyboard-arrow-left.svg" class="arrow left" />
    <img v-bind:src="currentImageSource" class="current-image" />
    <img v-on:click="nextSlide()" src="/static/img/icons/keyboard-arrow-right.svg" class="arrow right" />
  </div>
</template>


<script>

export default {
  name: 'BxCarousel',
  props: {
    modalProps: {
      type:     Object,
      default:  () => { return {} }
    }
  },
  data () {
    return {
      currentSlide: 1
    }
  },
  created () {
    // setTimeout(() => {
    //   $('.bx-carousel').on('swipe', (event) => {
    //     this.handleSwipe(event)
    //   })
    // }, 1000)
  },
  computed: {
    currentImageSource () {
      return require('../assets/images' + this.modalProps.imagePath + '_' + this.currentSlide + '.jpg')
    }
  },
  methods: {
    nextSlide () {
      if (this.currentSlide === this.modalProps.slideLength) this.$emit('close')
      else this.currentSlide += 1
    },
    prevSlide () {
      if (this.currentSlide === 1) return
      this.currentSlide -= 1
    }
  }
}
</script>

<style lang="scss" scoped>

.bx-carousel {
  position:                 relative;

  .arrow {
    height:                 1.5em;
    width:                  1.5em;
    position:               absolute;
    top:                    45%;
    cursor:                 pointer;
  }

  .current-image {
    display:              block !important;
    width:                80% !important;
    height:               auto;
    margin:               0 auto;
  }
}

/* Portrait tablet to landscape and desktop */
@media (max-width: 768px) {

  .bx-carousel {

    .current-image {
      width:              100% !important;
    }

    .right {
      right:              -1em;
    }

    .left {
      left:               -1em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/BxCarousel.vue